module.exports = __webpack_public_path__ + "static/media/rechazado icono.661f5439.svg";